import React from 'react';
import './Panels.css';

const Panels = ({ panelsData }) => {
  return (
    <section className="panels">
      <div className="panels-container">
        {panelsData.map((panel, index) => (
          <div key={index} className="panel">
            <div className="panel-image">
              <img
                src={panel.image || `https://via.placeholder.com/150?text=Bild+${index + 1}`}
                alt={panel.title}
              />
            </div>
            <div className="panel-text">
              <h3>{panel.title}</h3>
              <p>{panel.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Panels;
